import { useContext, useMemo } from 'react'
import { useFirestoreGeneralOrderBy } from '../../../firebase/useFirestore'
import Location from '../../../hooks/Location'
import { PersonaNavigation } from '../../../StateManagment/PersonaNavigation'

const PRIMARY_FIELDS = [
    { key: 'name', label: 'Naam', source: ['Voornaam', 'Achternaam'], join: ' ' },
    { key: 'birthdate', label: 'Geboortedatum', source: ['Geboortedatum'] },
    { key: 'street', label: 'Adres', source: ['Straatnaam', 'Huisnummer'], join: ' ' },
    { key: 'phone', label: 'Telefoonnummer', source: ['Telefoonnummer'] },
    { key: 'email', label: 'Email', source: ['Email'] },
]

const PrimaryDataCard = () => {
    const personaId = Location()[3]
    const [, setPersonaNavigation] = useContext(PersonaNavigation)

    const data = useFirestoreGeneralOrderBy(
        'PersonaData',
        'PersonaID',
        personaId || '',
        'Position',
        'asc'
    )

    const valueByTitle = useMemo(() => {
        const map = {}
        if (Array.isArray(data)) {
            data.forEach(item => {
                if (item && item.Title) map[item.Title] = item.Value || ''
            })
        }
        return map
    }, [data])

    return (
        <div className="new-dashboard-card">
            <div className="new-dashboard-card-content">
                <h3 className="new-dashboard-card-title">Primaire gegevens</h3>
                <ul className="adress-dashboard-data-list">
                    {PRIMARY_FIELDS.map(field => {
                        const parts = field.source
                            .map(title => valueByTitle[title])
                            .filter(v => v && v.trim())
                        const value = parts.length
                            ? parts.join(field.join || ' ')
                            : '—'
                        return (
                            <li key={field.key} className="adress-dashboard-data-row">
                                <span className="adress-dashboard-data-label">{field.label}</span>
                                <span className="adress-dashboard-data-value">{value}</span>
                            </li>
                        )
                    })}
                </ul>
                <button
                    type="button"
                    className="adress-dashboard-view-all"
                    onClick={() => setPersonaNavigation('data')}
                >
                    Bekijk alle gegevens →
                </button>
            </div>
        </div>
    )
}

export default PrimaryDataCard
